import axios from 'axios';

export default class PlanningApiService {

    async getPlannings() {
        //return await axios.get('http://18.202.236.131:9006/api/ocdscompliance/getPlanningList', { headers: { 'Access-Control-Allow-Origin': '*' } }).then(res => res.data);
        return await axios.get('https://adminapi.dppib-crsgov.org/api/ocdscompliance/getPlanningList', { headers: { 'Access-Control-Allow-Origin': '*' } }).then(res => res.data);
    }
    async getPlanningsWithYear(year) {
        return await axios.get('https://ocdsapi.dppib-crsgov.org/api/ocdsapi/getocidreleases?year=' + year, { headers: { 'Access-Control-Allow-Origin': '*' } }).then(res => res.data);
    }

    async getExistingYears() {
        var yearslist = await axios.get('https://ocdsapi.dppib-crsgov.org/api/ocdsapi/getExistingYearList').then(res => res.data);
        var arraylist = yearslist.map(element => ({ code: element, name: element }));
        //console.log(arraylist);
        return arraylist;
    }

    async getPlanningsWithMDA(mda) {
        return await axios.get('https://ocdsapi.dppib-crsgov.org/api/ocdsapi/getocidreleases?mda=' + mda, { headers: { 'Access-Control-Allow-Origin': '*' } }).then(res => res.data);
    }

    
    async getExcelExportPackageItem(id) {
        axios({
            url: 'https://ocdsapi.dppib-crsgov.org/api/ocdsAPI/getExcelPackageFile?id=' + id,
            method: 'GET',
            responseType: 'blob', // important
            headers: { 'Accept': 'application/vnd.ms-excel' }
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            
            link.setAttribute('download', id + '-' +'ReleasePackage.xlsx');
            document.body.appendChild(link);
            link.click();
        });
    }

    async getReleasePackageItem(year, month) {
        axios({
            url: 'https://ocdsapi.dppib-crsgov.org/api/ocdsAPI/getReleasePackage?year=' + year + '&month=' + month,
            method: 'GET',
            responseType: 'blob', // important
            headers: { 'Accept': 'application/json' }
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            
            link.setAttribute('download', year + month + '-' +'ReleasePackage.json');
            document.body.appendChild(link);
            link.click();
        });
    }

    async getRecordPackageItem(year, month) {
        axios({
            url: 'https://ocdsapi.dppib-crsgov.org/api/ocdsAPI/getRecordPackage?year=' + year + '&month=' + month,
            method: 'GET',
            responseType: 'blob', // important
            headers: { 'Accept': 'application/json' }
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            
            link.setAttribute('download', year + month + '-' +'RecordPackage.json');
            document.body.appendChild(link);
            link.click();
        });
    }

}